import { useMutation } from '@tanstack/react-query';
import { deleteStoreData } from '../services/deleteStoreData';
import { StoreIdRequiredError } from '../errors/storeIdRequired';
import { useStoreData } from '../hooks/useStoreData';

export const useDeleteStoreData = () => {
    const { storeData } = useStoreData();
    const storeId = storeData?.id;

    return useMutation({
        mutationFn: () => {
            if (!storeId) throw new StoreIdRequiredError();

            return deleteStoreData(storeId);
        },
        retry: 2,
    });
};
